import type { Page } from '@/domain/model/Page';
import type { ManagedUser, CreateUserCommand, UpdateUserCommand } from '@/domain/model/ManagedUser';
import type { UserGateway, ListUsersParams } from '@/application/port/out/UserGateway';
import type {
  ListUsersUseCase, CreateUserUseCase, UpdateUserUseCase,
  DeactivateUserUseCase, BlockUserUseCase, UnblockUserUseCase,
} from '@/application/port/in/UserUseCase';

export class ListUsers implements ListUsersUseCase {
  constructor(private readonly g: UserGateway) {}
  execute(params: ListUsersParams): Promise<Page<ManagedUser>> { return this.g.list(params); }
}
export class CreateUser implements CreateUserUseCase {
  constructor(private readonly g: UserGateway) {}
  execute(cmd: CreateUserCommand): Promise<ManagedUser> { return this.g.create(cmd); }
}
export class UpdateUser implements UpdateUserUseCase {
  constructor(private readonly g: UserGateway) {}
  execute(id: string, cmd: UpdateUserCommand): Promise<ManagedUser> { return this.g.update(id, cmd); }
}
export class DeactivateUser implements DeactivateUserUseCase {
  constructor(private readonly g: UserGateway) {}
  execute(id: string): Promise<void> { return this.g.deactivate(id); }
}
export class BlockUser implements BlockUserUseCase {
  constructor(private readonly g: UserGateway) {}
  execute(id: string): Promise<void> { return this.g.block(id); }
}
export class UnblockUser implements UnblockUserUseCase {
  constructor(private readonly g: UserGateway) {}
  execute(id: string): Promise<void> { return this.g.unblock(id); }
}
